import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Brain from "@/pages/Brain";
import ArchivePage from "@/pages/ArchivePage";
import EntryDetail from "@/pages/EntryDetail";
import ShortcutPage from "@/pages/ShortcutPage";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";

function Protected() {
  return (
    <>
      <Show when="signed-in">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/brain" element={<Brain />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/entry/:id" element={<EntryDetail />} />
            <Route path="/shortcut" element={<ShortcutPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </Show>
      <Show when="signed-out">
        <Navigate to="/sign-in" replace />
      </Show>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route path="*" element={<Protected />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
